<template>
	<v-template>
		<v-row>
			<v-col cols="12" class="display-1 text-center">
				Productos adicionales
			</v-col>
		</v-row>
		<v-expand-transition>
			<v-row v-show="obteniendoAdicionales">
				<v-col cols="12" class="d-flex justify-center">
					<v-progress-circular :size="150" :width="15" indeterminate color="primary"/>
				</v-col>
				<v-col cols="12" class="text-center">
					Obteniendo adicionales disponibles...
				</v-col>
			</v-row>
		</v-expand-transition>
		<v-row v-if="hayAdicionales">
			<v-col cols="12" v-if="datosAdicionales.length===0">
				<v-alert outlined type="info">
					Este plan actualmente no tiene adicionales para seleccionar.
					Continue al siguiente paso de contratación.
				</v-alert>
			</v-col>
			<v-col cols="12" sm="6" md="4" v-for="datoAdicional in datosAdicionales">
				<v-card class="d-flex flex-column pa-2" height="100%" elevation="0" color="grey lighten-4">
					<!-- Parte superior de contenido -->
					<v-sheet class="pa-1 mb-auto" color="transparent">
						<div class="d-flex justify-center" v-if="datoAdicional.adicional.urlAvatar">
							<v-img :src="datoAdicional.adicional.urlAvatar" max-height="170" contain eager transition="scale-transition" />
						</div>
						<div class="text-center">
							<div :class="['py-1', 'headline', 'font-weight-black']">
								{{ datoAdicional.adicional.nombre }}
							</div>
							<div class="subtitle-2">
								{{ datoAdicional.adicional.nombreValor }}
							</div>
							<div v-if="!datoAdicional.adicional.valor">
								<span class="title font-weight-black">
									¡Gratis!
								</span>
							</div>
							<div v-else-if="datoAdicional.adicional.cantidadMaximaGratis">
								<span v-if="datoAdicional.cantidad > datoAdicional.adicional.cantidadMaximaGratis"
									class="title font-weight-black">
									$ {{ formatearMoneda(datoAdicional.adicional.valor*(datoAdicional.cantidad - datoAdicional.adicional.cantidadMaximaGratis)) }} + IVA
								</span>
								<span v-else class="title font-weight-black">
									¡Gratis!
								</span>
								<br>
								<span class="subtitle-2">
									(hasta {{ datoAdicional.adicional.cantidadMaximaGratis }} gratis)
								</span>
							</div>
							<div v-else>
								$ {{ formatearMoneda(datoAdicional.adicional.valor*datoAdicional.cantidad) }} + IVA
							</div>
						</div>
						<div class="py-1">
							<v-divider></v-divider>
						</div>
						<div class="py-1 text-left">
							<div v-for="caracteristica in datoAdicional.adicional.caracteristicas" class="body-2">
								<v-icon small color="green" left class="mr-0">
									check
								</v-icon>
								{{ caracteristica }}
							</div>
						</div>
					</v-sheet>
					<!-- Parte inferior de contenido -->
					<v-sheet class="pa-1 mt-1 text-center" color="white">
						<div>
							<v-checkbox v-model="datoAdicional.desactivado" label="Seleccionar" :disabled="!datoAdicional.adicional.desactivable"
								:true-value="false" :false-value="true" hide-details>
							</v-checkbox>
						</div>
						<div v-if="(datoAdicional.adicional.cantidadMaxima === datoAdicional.adicional.cantidadMinima)">
							<span v-if="datoAdicional.cantidad === 1">
								Es
							</span>
							<span v-else>
								Son
							</span>
							<b>{{ datoAdicional.cantidad }}</b> con el plan elegido.
						</div>
						<div class="text-center py-1" v-else>
							<v-btn v-on:click.stop="sumarCantidad(datoAdicional, -1)" 
								:disabled="(datoAdicional.cantidad <= datoAdicional.adicional.cantidadMinima)" 
								color="primary" icon depressed>
								<v-icon>
									remove
								</v-icon>
							</v-btn>
							<span class="mx-2">
								{{ datoAdicional.cantidad }}
							</span>
							<v-btn v-on:click.stop="sumarCantidad(datoAdicional, +1)" color="primary" icon depressed
								:disabled="(datoAdicional.cantidad >= datoAdicional.adicional.cantidadMaxima)">
								<!-- Nota: Si cantidadMaxima es undefined, la comparación de arriba siempre dará false -->
								<v-icon>
									add
								</v-icon>
							</v-btn>
						</div>
					</v-sheet>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-checkbox v-model="acepta" label="He revisado los los productos adicionales"
					hide-details :disabled="obteniendoAdicionales"/>
			</v-col>
		</v-row>
	</v-template>
</template>

<script>
import numeral from 'numeral';
import * as config from '@/config';
import { API } from 'aws-amplify';

let contadorGeneracionAdicionales = 0;

export default {
	props: {
		'datos-plan': {
			type: Object,
			default: {},
		},
		'activo': {
			type: Boolean,
			default: false,
		}
	},
	data: () => ({
		datosAdicionales: undefined,
		adicionalesDesactualizados: false,
		obteniendoAdicionales: false,
		acepta: false,
	}),
	computed: {
		hayAdicionales: function() {
			let vm = this;
			let datosAdicionales = vm.datosAdicionales;
			let hay = (datosAdicionales !== undefined);
			return hay;
		},
	},
	methods: {
		sumarCantidad: function(datoAdicional, delta) {
			let cantidadActual = datoAdicional.cantidad;
			datoAdicional.cantidad = cantidadActual + delta;
		},
		generarAdicionales: async function() {
			// Podrían haber varias invocaciones de esta función en paralelo. Asignar a cada invocación un identificador único, lo cual
			// permite mostrarle al usuario solo el resultado de la última invocación.
			let vm = this;
			let identificadorInvocacion = ++contadorGeneracionAdicionales;
			vm.datosAdicionales = undefined;
			if((vm.datosPlan === undefined)) {
				vm.notificar('Para generar los adicionales a elegir se requiere de un plan', 'error');
				return;
			}
			let apiName = config.autocontratarApiName;
			let path = '/generar-adicionales';
			let datosPlan = vm.datosPlan;
			let init = {
				headers: {},
				body: {
					datosPlan,
				},
			};
			vm.obteniendoAdicionales = true;
			try {
				let response = await API.post(apiName, path, init);
				if(identificadorInvocacion !== contadorGeneracionAdicionales) { return; } // Inhibir, simular que aún se está generando.
				let adicionales = response.adicionales;
				let datosAdicionales = adicionales.map(a => ({ 
					cantidad: a.cantidadPredeterminada, // Inicializar cantidad con el valor de cantidadPredeterminada del adicional
					adicional: a,
					desactivado: a.desactivadoPorDefecto, // Siempre desactivadoPorDefecto === desactivado
				}));
				if(adicionales && (adicionales.length === 0)) {
					// Si no hay nada que elegir, aceptar inmediatamente este paso
					vm.acepta = true;
				}
				vm.datosAdicionales = datosAdicionales;
			}
			catch(e) {
				if(identificadorInvocacion !== contadorGeneracionAdicionales) { return; } // Inhibir, simular que aún se está generando.
				vm.notificar(`Error al generar adicionales a elegir. Intente recargar esta página.`, 'error');
			}
			vm.adicionalesDesactualizados = false;
			vm.obteniendoAdicionales = false;
		},
		notificar: function(mensaje, tipo) {
			let vm = this;
			vm.$emit('notificacion', {mensaje, tipo});
		},
		emitirDatos: function(valido, datosAdicionales) {
			// valido proviene de watch acepta
			let vm = this;
			let datos;
			if(datosAdicionales) {
				// Si hay, emitir solo los elegidos
				datos = vm.datosAdicionales.filter(a => (a.cantidad > 0) && (!a.desactivado));
			}
			vm.$emit('datos', valido, datos);
		},
		formatearMoneda: function(cifra, moneda='CLP') {
			let formateado;
			if(moneda === 'CLF') {
				formateado = numeral(cifra).format('0,0[.][0000]'); // Precaución con más de 4 decimales
			}
			else {
				// Asumir CLP
				formateado = numeral(cifra).format();
			}
			return formateado;
		},
	},
	mounted: function() {
		// Nada
	},
	watch: {
		acepta: function(newVal) {
			let vm = this;
			let datosAdicionales = vm.datosAdicionales;
			vm.emitirDatos(newVal, datosAdicionales);
		},
		datosAdicionales: {
			deep: true,
			immediate: true,
			handler:  function(newVal) {
				let vm = this;
				let acepta = vm.acepta;
				vm.emitirDatos(acepta, newVal);
			},
		},
		datosPlan: {
			deep: true,
			immediate: true,
			handler: function(newVal) {
				let vm = this;
				vm.adicionalesDesactualizados = true;
				vm.acepta = false;
			},
		},
		activo: {
			immediate: true,
			handler: function(newVal) {
				let vm = this;
				if(newVal) {
					if(vm.adicionalesDesactualizados || !vm.hayAdicionales) {
						vm.generarAdicionales();
					}
				}
			}
		},
	}
};
</script>
